export default __webpack_public_path__ + "static/media/banner.78f6c418.png";